import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
    const isLoggedIn = localStorage.getItem('userid') && localStorage.getItem('token');
    const navigate = useNavigate();
  
    useEffect(() => {
      if (!isLoggedIn) {
        // Redirect to login page if not logged in
        navigate('/site/signin');
      }
    }, [isLoggedIn, navigate]);
  
    return isLoggedIn ? children : null;
};
